
export const GET_TOKENS = 'GET_TOKENS';
export const GET_CONTACTDETAILS = 'GET_CONTACTDETAILS';
export const GET_CLIENTDETAILS = 'GET_CLIENTDETAILS';
export const USER_LOGOUT = 'USER_LOGOUT';
export const GET_CAPTCHA = 'GET_CAPTCHA';


export function getTockens(dataFromMic){
    return{
        type:GET_TOKENS,
        dataFromMic:dataFromMic
    }
}
export function getcontactDetails(contactDetails){
    return{
        type:GET_CONTACTDETAILS,
        contactDetails:contactDetails
    }
}
export function getClientDetails(clientDetails){
    return{
        type:GET_CLIENTDETAILS,
        clientDetails:clientDetails
    }
}
export function userLogout(){
    return{
        type:USER_LOGOUT,
    }
}
export function getCaptcha(captchaValue){
    return{
        type:GET_CAPTCHA,
        captchaValue:captchaValue
    }
}